export enum SortByEnum {
    LastIdAuthDocumentSignature = 1,
    Service = 2,
    LegalEntity = 3,
    ForPerson = 4,
    Person = 5,
    FromLegal = 6,
    ToPerson = 7,
    ToPersonLegal = 8,
    DocumentState = 9
}